export class FileUtil {
    static fileName(path: string | undefined) {
        return path?.split(/[\\/]/).pop() ?? ''
    }

    static stripExtension(fileName: string) {
        return fileName.replace(/\.[^.]+$/, '')
    }

    static extension(fileName: string) {
        const m = fileName.match(/\.[^.]+$/)
        return m ? m[0].toLowerCase() : ''
    }

    static folder(path: string | undefined) {
        if (!path) {
            return undefined
        }
        const idx = Math.max(path.lastIndexOf('\\'), path.lastIndexOf('/'))
        return idx > 0 ? path.slice(0, idx) : undefined
    }
}
